import React from 'react'
import ReactPlayer from 'react-player/lazy'
const VideoBox = ({ url, parameters,onVideoPlay  = {}, aiStatus, element, renderAiOverlay = () => null }) => {
    return (
        <div>
            <ReactPlayer className='react-player' onPlay={onVideoPlay} style={{
                 minHeight: "8rem",
                maxHeight: "14rem"
            }} url={url} width='100%'
                config={{
                    file: {
                        attributes: {
                            controlsList: 'nodownload'
                        }
                    }
                }} controls styles={{}} {...parameters}  />
            {renderAiOverlay(aiStatus, element)}
        </div>
    )
}

export default React.memo(VideoBox)